import React from 'react';
import Link from 'gatsby-link';

import PageHeader from '../../components/header/page';
import ContentBlock from '../../components/contentblock';
import SidebarNav from '../../components/navigation/sidebar';
import InfoBox from '../../components/navigation/infobox';
import BackgroundImage from '../../resources/images/header/roentgen.jpg';

const RoentgenPage = props =>
  (<main>
    <PageHeader headline="Digitales Röntgen" image={BackgroundImage}/>
    <section className="container-custom split">
    <div className="container-custom">
      <ContentBlock title="Vorbereitungen zu Hause:">
        <ul className="feature-list">
          <li>
            Die Untersuchungsregion muss frei von Kleidung und Schmuck sein.
          </li>
          <li>
            Bringen Sie Ihre <strong>Vorbefunde</strong> mit (OP-Berichte, Röntgenbilder etc.).
          </li>
        </ul>
      </ContentBlock>
      <ContentBlock title="Vorbereitungen in der Ordination:">
        <ul className="feature-list">
          <li>
            Füllen Sie in der Ordination das <strong>Anamneseblatt</strong> aus.
          </li>
          <li>
            Spezielle Röntgenuntersuchungen erfolgen ausschließlich nach <strong>Terminvereinbarung</strong>:
            <ul>
              <li>
                Schluckaktröntgen
              </li>
              <li>
                Magenröntgen
              </li>
              <li>
                Irrigoskopie
              </li>
              <li>
                IVP
              </li>
            </ul>
          </li>
        </ul>
      </ContentBlock>
      <ContentBlock title="Befundsbesprechung:">
        <ul className="feature-list">
          <li>
            Die <strong>Befundbesprechung</strong> erfolgt beim überweisenden Arzt/Ärztin.
          </li>
        </ul>
      </ContentBlock>
      </div>
      <aside className="sidebar">
          <SidebarNav />
          <InfoBox name="roentgen" />
        </aside>
    </section>
  </main>);

export default RoentgenPage;


// WEBPACK FOOTER //
// ./src/pages/leistungen/roentgen.js